import(/* webpackMode: "eager" */ "/Users/welcome/Documents/NKS/A0. Projects/sunny-business-card/node_modules/next/dist/client/link.js");
